import InlineText from '@/design_system/Typography/InlineText';
import Paragraph from '@/design_system/Typography/Paragraph';
import {
  getProductAttributesTree,
  type ProductAttributeTreeNode,
  type ProductAttributeTreeValueNode,
  type ProductAttributeValuesForTree,
} from '@/models/product';
import { useDatabaseTranslation } from '@/services/i18n';

import './ProductAttributeTrees.css';

export const ProductAttributeTrees = ({
  productAttributeValues,
}: {
  productAttributeValues: ProductAttributeValuesForTree;
}) => {
  const productAttributesTreeNodes = getProductAttributesTree(productAttributeValues);

  return (
    <div className="settings__product-attribute-trees">
      <ul>
        {productAttributesTreeNodes.map((productAttributeTreeNode) => (
          <ProductAttributeTreeNode
            key={productAttributeTreeNode.attribute.id}
            productAttributeTreeNode={productAttributeTreeNode}
          />
        ))}
      </ul>
    </div>
  );
};

const ProductAttributeTreeNode = ({
  productAttributeTreeNode,
}: {
  productAttributeTreeNode: ProductAttributeTreeNode;
}) => {
  return (
    <ul>
      {productAttributeTreeNode.values.map((productAttributeTreeValueNode) => (
        <ProductAttributeTreeValueNode
          key={productAttributeTreeValueNode.value.id}
          productAttribute={productAttributeTreeNode.attribute}
          productAttributeTreeValueNode={productAttributeTreeValueNode}
        />
      ))}
    </ul>
  );
};

const ProductAttributeTreeValueNode = ({
  productAttribute,
  productAttributeTreeValueNode,
}: {
  productAttribute: ProductAttributeTreeNode['attribute'];
  productAttributeTreeValueNode: ProductAttributeTreeValueNode;
}) => {
  const { _db } = useDatabaseTranslation();

  return (
    <li>
      <Paragraph size="200">
        {_db(productAttribute.name)}:{' '}
        <InlineText size="200" weight="medium">
          {_db(productAttributeTreeValueNode.value.name)}
        </InlineText>
      </Paragraph>
      {productAttributeTreeValueNode.childAttributes.length > 0 && (
        <ul>
          {productAttributeTreeValueNode.childAttributes.map((productAttributeTreeNode) => (
            <ProductAttributeTreeNode
              key={productAttributeTreeNode.attribute.id}
              productAttributeTreeNode={productAttributeTreeNode}
            />
          ))}
        </ul>
      )}
    </li>
  );
};
